import { NotificationItem } from '../../features/notifications/models/notification';
import { SalesOrder } from '../../features/sales-orders/models/sales-order';
import { CustomerPickupRequest } from '../../features/cprs/models/customer-pickup-request';
import { BillingSearchResult } from '../../features/reports/services/report.service';

export enum SidebarPanelType {
  NotificationList = 'notification-list',
  NotificationDetail = 'notification-detail',
  SearchResults = 'search-results',
  SalesOrderDetail = 'sales-order-detail',
  CprDetail = 'cpr-detail',
  InvoiceDetail = 'invoice-detail'
}

export type SidebarPanel =
  | { type: SidebarPanelType.NotificationList }
  | { type: SidebarPanelType.NotificationDetail; data: NotificationItem }
  | { type: SidebarPanelType.SearchResults; data?: { query: string } }
  | { type: SidebarPanelType.SalesOrderDetail; data: SalesOrder }
  | { type: SidebarPanelType.CprDetail; data: CustomerPickupRequest }
  | { type: SidebarPanelType.InvoiceDetail; data: BillingSearchResult };
